// The paper describing the NiiVue wrapper ecosystem; shown in the About and
// Cite dialogs, after saving a screenshot, and embedded in exported screenshots.
export const CITATION_DOI_URL = 'https://doi.org/10.52294/001c.167815'
export const CITATION_TEXT =
  'Eckstein K, Androulakis A, Dao TT, et al. Seamless neuroimaging visualization: The NiiVue wrapper ecosystem. Aperture Neuro. 2026;6.'
export const CITATION_SHORT = 'Eckstein et al., Aperture Neuro 2026'
export const CITATION_BIBTEX = `@article{eckstein2026niivue,
  title   = {Seamless neuroimaging visualization: The {NiiVue} wrapper ecosystem},
  author  = {Eckstein, Korbinian and Androulakis, Anthony and Dao, Thuy T. and Drake, Chris and Hanayik, Taylor and O'Reilly, Christian and Prahm, Cosima and Wang, Zhengjia and Wighton, Paul and Dalca, Adrian and Bollmann, Steffen and Rorden, Chris},
  journal = {Aperture Neuro},
  volume  = {6},
  year    = {2026},
  doi     = {10.52294/001c.167815}
}`
